import { hasConsent, setConsent, initGA } from './analytics.js';

export function initCookieConsent(): void {
  // If already consented, just init GA
  if (hasConsent()) {
    initGA();
    return;
  }

  // Check if denied previously
  if (localStorage.getItem('split_analytics_consent') === 'denied') {
    return;
  }

  // Show consent banner
  const banner = document.createElement('div');
  banner.className = 'cookie-consent';
  banner.innerHTML = `
    <div class="cookie-consent-content">
      <div class="cookie-consent-text">
        <span class="cookie-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0"/>
            <path d="M14 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>
            <path d="M15 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>
          </svg>
        </span>
        <p>We use analytics cookies to improve your experience. No personal data is shared with third parties.</p>
      </div>
      <div class="cookie-consent-actions">
        <button class="btn btn-small cookie-decline">Decline</button>
        <button class="btn btn-primary btn-small cookie-accept">Accept</button>
      </div>
    </div>
  `;

  document.body.appendChild(banner);

  // Animate in
  requestAnimationFrame(() => banner.classList.add('cookie-consent-visible'));

  // Handle accept
  banner.querySelector('.cookie-accept')?.addEventListener('click', () => {
    setConsent(true);
    closeBanner(banner);
  });

  // Handle decline
  banner.querySelector('.cookie-decline')?.addEventListener('click', () => {
    setConsent(false);
    closeBanner(banner);
  });
}

function closeBanner(banner: HTMLElement): void {
  banner.classList.remove('cookie-consent-visible');
  banner.classList.add('cookie-consent-hiding');
  setTimeout(() => banner.remove(), 300);
}
